<script module>
  import Content from "./Content.svelte";
  import * as systemBanner from "@sourcewhale/shared/svelte-design-system/components/atoms/SystemBanner/utils.svelte";

  let crms = $state([]);

  const showDisconnected = (_crms) => {
    if (!_crms || _crms.length === 0) return;

    crms = _crms;
    systemBanner.addNotification({
      props: {
        kind: "warning",
        leadingIcon: "fa-solid fa-link-horizontal-slash",
      },
      content,
      timeout: 45000,
    });
  };

  export { content, showDisconnected };
</script>

{#snippet content()}
  <Content {crms} />
{/snippet}
